<template>
  <div>
    <d-data-table
      ref="data-table"
      fluid
      resource="owner-businesses"
      :show-button="false"
      :url="$laravel.route(`api.owner-businesses.index`, owner_id)"
      searchable
      :edit-url="(row) => `/owners/${owner_id}/owner-businesses/${row.id}/edit`"
      no-padding
    >
      <template #actions="{ row }">
        <button
          v-if="
            $laravel.user.role != 'client' ||
              $laravel.user.owner_id ||
              ($laravel.user.is_owner_contact &&
                $laravel.user.contact.is_admin_contact)
          "
          class="button is-small is-white"
          @click="openPermissionModal(row)"
        >
          <div
            class="icon"
            :class="{
              'has-text-success': row.owner_contacts_count > 0,
              'has-text-danger': row.owner_contacts_count == 0,
            }"
          >
            <i class="mdi mdi-lock mdi-18px" />
          </div>
        </button>
      </template>
      <b-table-column
        v-slot="props"
        field="name"
        :label="$t('name')"
        sortable
      >
        {{ props.row.name }}
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="created_at"
        sortable
        :label="$t('attributes.created_at').capitalize()"
        :visible="$mq == 'mobile' || $mq == 'fullhd'"
      >
        <div class="is-size-7">
          {{ $dayjs(props.row.created_at).format("LLL") }}
        </div>
      </b-table-column>
    </d-data-table>

    <b-modal
      v-model="isShownModalPermissions"
      :width="600"
      @success="reloadDataTable"
      @close="closePermissionsModal"
    >
      <div class="modal-card round-b">
        <header
          class="modal-card-head is-flex-direction-column is-flex is-align-items-flex-start"
        >
          <div
            class="is-flex is-full is-align-content-space-between"
            style="width: 100%"
          >
            <p class="modal-card-title title mb-0">
              {{ $t("owner_businesses") }}
            </p>
            <button
              class="delete"
              aria-label="close"
              @click="closePermissionsModal"
            />
          </div>
        </header>

        <section class="modal-card-body p-0">
          <ul
            v-if="ownerContacts"
            class="is-flex is-flex-direction-column"
          >
            <li
              v-for="(contact, index) in ownerContacts"
              :key="index"
              class="is-flex is-justify-content-space-between is-align-items-center px-5 py-3 border-b"
            >
              <p>
                {{ contact.name }}
              </p>
              <div class="action">
                <button
                  class="button is-small is-white"
                  @click="toggleOwnerContactPermissions(contact)"
                >
                  <div class="icon">
                    <i
                      v-if="contact.owner_business.length == 0"
                      class="mdi mdi-lock is-size-5 is-success has-text-grey"
                    />
                    <i
                      v-if="contact.owner_business.length > 0"
                      class="mdi mdi-lock-open is-size-5 has-text-success"
                    />
                  </div>
                </button>
              </div>
            </li>
          </ul>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    owner_id: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      isShownModalPermissions: false,
      ownerContacts: null,
      loading: false,
      ownerBusiness: null,
    };
  },
  mounted() {
    const isSaved = this.$route.query.saved;
    const ownerBusinessesId = this.$route.query.owner_business_id;

    // check if user can update permissions
    if (
      this.$laravel.user.contact &&
      !this.$laravel.user.contact?.is_admin_contact
    ) {
      return false;
    }

    if (isSaved != undefined && ownerBusinessesId != undefined) {
      this.getOwnerBusinessById(ownerBusinessesId);
    }
  },
  methods: {
    openPermissionModal(row) {
      this.isShownModalPermissions = true;
      this.ownerBusiness = row;

      this.getOwnerContactList();
    },
    closePermissionsModal() {
      this.isShownModalPermissions = false;
      this.removeQueryParameters();
    },
    reloadDataTable() {
      console.log("reload data table");
    },
    getOwnerContactList() {
      this.loading = true;
      this.$http
        .get(
          route("api.owner-businesses.contacts", {
            owner: this.owner_id,
            ownerBusiness: this.ownerBusiness.id,
          })
        )
        .then((response) => {
          this.loading = false;
          this.ownerContacts = response.data.data;
        });
      this.loading = false;
    },
    async toggleOwnerContactPermissions(contact) {
      const formData = new FormData();
      formData.append("action", true);

      this.$http
        .post(
          route("api.owner-businesses.permissions", {
            owner: this.owner_id,
            ownerBusiness: this.ownerBusiness.id,
            ownerContact: contact.id,
          }),
          formData
        )
        .then((response) => {
          this.getOwnerContactList();
          this.$refs["data-table"].loadData();
        });
    },
    getOwnerBusinessById(id) {
      this.$http
        .get(
          this.$laravel.route("api.owner-businesses.show", {
            owner: this.owner_id,
            owner_business: id,
          })
        )
        .then((response) => {
          this.ownerBusiness = response.data.data;
          this.openPermissionModal(this.ownerBusiness);
        });
    },
    removeQueryParameters() {
      const isSaved = this.$route.query.saved;
      const ownerBusinessesId = this.$route.query.owner_business_id;
      if (isSaved != undefined && ownerBusinessesId != undefined) {
        const { path, hash, params } = this.$route;
        this.$router.replace({ path, hash, params });
      }
    },
  },
};
</script>

<style scoped>
.border-b {
  border-bottom: solid 1px #ebebeb;
}
.round-b {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
</style>
